import React from 'react';
import emailjs from '@emailjs/browser';

class Contactme extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            formData: {
                name: '',
                email: '',
                subject: '',
                message: ''
            },
            errors: {},
            isSubmitting: false,
            submitStatus: null
        }
    }

    // Validation rules
    validationRules = {
        name: {
            required: true,
            minLength: 2,
            maxLength: 50,
            pattern: /^[a-zA-Z\s]+$/
        },
        email: {
            required: true,
            pattern: /^[^\s@]+@[^\s@]+\.[^\s@]+$/,
            maxLength: 100
        },
        subject: {
            required: true,
            minLength: 5,
            maxLength: 100
        },
        message: {
            required: true,
            minLength: 10,
            maxLength: 1000
        }
    };

    validateField = (name, value) => {
        const rules = this.validationRules[name];
        const errors = [];

        if (rules.required && !value.trim()) {
            errors.push(`${this.getFieldLabel(name)} is required`);
        }

        if (value.trim()) {
            if (rules.minLength && value.trim().length < rules.minLength) {
                errors.push(`${this.getFieldLabel(name)} must be at least ${rules.minLength} characters`);
            }

            if (rules.maxLength && value.trim().length > rules.maxLength) {
                errors.push(`${this.getFieldLabel(name)} must not exceed ${rules.maxLength} characters`);
            }

            if (rules.pattern && !rules.pattern.test(value.trim())) {
                if (name === 'email') {
                    errors.push('Please enter a valid email address');
                } else if (name === 'name') {
                    errors.push('Name should only contain letters and spaces');
                }
            }
        }

        return errors;
    };

    getFieldLabel = (name) => {
        const labels = {
            name: 'Name',
            email: 'Email',
            subject: 'Subject',
            message: 'Message'
        };
        return labels[name];
    };

    validateForm = () => {
        const { formData } = this.state;
        const errors = {};

        Object.keys(formData).forEach(field => {
            const fieldErrors = this.validateField(field, formData[field]);
            if (fieldErrors.length > 0) {
                errors[field] = fieldErrors[0];
            }
        });

        return errors;
    };

    handleInputChange = (e) => {
        const { name, value } = e.target;
        const { formData, errors } = this.state;

        // Update form data
        const newFormData = {
            ...formData,
            [name]: value
        };

        // Clear error for this field if it becomes valid
        const fieldErrors = this.validateField(name, value);
        const newErrors = { ...errors };
        if (fieldErrors.length === 0) {
            delete newErrors[name];
        }

        this.setState({
            formData: newFormData,
            errors: newErrors
        });
    };

    handleBlur = (e) => {
        const { name, value } = e.target;
        const fieldErrors = this.validateField(name, value);
        
        if (fieldErrors.length > 0) {
            this.setState(prevState => ({
                errors: {
                    ...prevState.errors,
                    [name]: fieldErrors[0]
                }
            }));
        }
    };

    resetForm = () => {
        this.setState({
            formData: {
                name: '',
                email: '',
                subject: '',
                message: ''
            },
            errors: {},
            isSubmitting: false,
            submitStatus: null
        });
    };

    handleSubmit = async (e) => {
        e.preventDefault();
        
        const errors = this.validateForm();
        
        if (Object.keys(errors).length > 0) {
            this.setState({ errors });
            return;
        }

        this.setState({ isSubmitting: true, submitStatus: null });

        try {
            // EmailJS configuration
            const templateParams = {
                from_name: this.state.formData.name,
                from_email: this.state.formData.email,
                subject: this.state.formData.subject,
                message: this.state.formData.message,
                to_name: 'Dhruvin',
                reply_to: this.state.formData.email
            };

            await emailjs.send(
                'service_1rq9qkq',        // Your EmailJS service ID
                'template_k38d5nc',       // Your EmailJS template ID
                templateParams,
                '6ZhVKzN7g-R0ovv3a'       // Your EmailJS public key
            );

            this.setState({
                submitStatus: 'success',
                isSubmitting: false
            });
            
            setTimeout(() => {
                this.resetForm();
            }, 3000);

        } catch (error) {
            console.error('Form submission error:', error);
            this.setState({
                submitStatus: 'error',
                isSubmitting: false
            });
        }
    };
    render() {
        const { formData, errors, isSubmitting, submitStatus } = this.state;

        return (
            <div className="vg-page page-contact" id="contact">
                <div className="container-fluid">
                    <div className="contact-header">
                        <h1 className="contact-title">Get in Touch</h1>
                        <p className="contact-subtitle">
                            Have a project in mind or want to discuss opportunities?
                            I'd love to hear from you.
                        </p>
                    </div>

                    <div className="contact-content">
                        <div className="contact-form-container">
                            {submitStatus === 'success' && (
                                <div className="alert alert-success">
                                    <div className="alert-icon">✓</div>
                                    <div className="alert-content">
                                        <h4>Message Sent Successfully!</h4>
                                        <p>Thank you for reaching out. I'll get back to you soon.</p>
                                    </div>
                                </div>
                            )}

                            {submitStatus === 'error' && (
                                <div className="alert alert-error">
                                    <div className="alert-icon">✕</div>
                                    <div className="alert-content">
                                        <h4>Something went wrong</h4>
                                        <p>Please try again or contact me directly via email.</p>
                                    </div>
                                </div>
                            )}

                            <form className="modern-contact-form" onSubmit={this.handleSubmit}>
                                <div className="form-grid">
                                    <div className="form-group">
                                        <label htmlFor="name" className="form-label">
                                            Name <span className="required">*</span>
                                        </label>
                                        <input
                                            type="text"
                                            id="name"
                                            name="name"
                                            className={`form-input ${errors.name ? 'error' : ''}`}
                                            value={formData.name}
                                            onChange={this.handleInputChange}
                                            onBlur={this.handleBlur}
                                            placeholder="Your full name"
                                            maxLength="50"
                                        />
                                        {errors.name && <span className="error-message">{errors.name}</span>}
                                        <div className="char-count">{formData.name.length}/50</div>
                                    </div>

                                    <div className="form-group">
                                        <label htmlFor="email" className="form-label">
                                            Email <span className="required">*</span>
                                        </label>
                                        <input
                                            type="email"
                                            id="email"
                                            name="email"
                                            className={`form-input ${errors.email ? 'error' : ''}`}
                                            value={formData.email}
                                            onChange={this.handleInputChange}
                                            onBlur={this.handleBlur}
                                            placeholder="your.email@example.com"
                                            maxLength="100"
                                        />
                                        {errors.email && <span className="error-message">{errors.email}</span>}
                                        <div className="char-count">{formData.email.length}/100</div>
                                    </div>

                                    <div className="form-group form-group-full">
                                        <label htmlFor="subject" className="form-label">
                                            Subject <span className="required">*</span>
                                        </label>
                                        <input
                                            type="text"
                                            id="subject"
                                            name="subject"
                                            className={`form-input ${errors.subject ? 'error' : ''}`}
                                            value={formData.subject}
                                            onChange={this.handleInputChange}
                                            onBlur={this.handleBlur}
                                            placeholder="What's this about?"
                                            maxLength="100"
                                        />
                                        {errors.subject && <span className="error-message">{errors.subject}</span>}
                                        <div className="char-count">{formData.subject.length}/100</div>
                                    </div>

                                    <div className="form-group form-group-full">
                                        <label htmlFor="message" className="form-label">
                                            Message <span className="required">*</span>
                                        </label>
                                        <textarea
                                            id="message"
                                            name="message"
                                            className={`form-textarea ${errors.message ? 'error' : ''}`}
                                            value={formData.message}
                                            onChange={this.handleInputChange}
                                            onBlur={this.handleBlur}
                                            placeholder="Tell me about your project or inquiry..."
                                            rows="6"
                                            maxLength="1000"
                                        />
                                        {errors.message && <span className="error-message">{errors.message}</span>}
                                        <div className="char-count">{formData.message.length}/1000</div>
                                    </div>

                                    <div className="form-group form-group-full">
                                        <button
                                            type="submit"
                                            className={`submit-btn ${isSubmitting ? 'loading' : ''}`}
                                            disabled={isSubmitting}
                                        >
                                            {isSubmitting ? (
                                                <>
                                                    <span className="spinner"></span>
                                                    Sending...
                                                </>
                                            ) : (
                                                <>
                                                    Send Message
                                                    <span className="btn-arrow">→</span>
                                                </>
                                            )}
                                        </button>
                                    </div>
                                </div>
                            </form>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

export default Contactme;